import CLECertificatePage from './CLECertificatePage';

export default CLECertificatePage;
